/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Badge_ActiveInputs */

const tr_landing_pricerules_mock_badge_active = /** @type {(inputs: Landing_Pricerules_Mock_Badge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktif`)
};

const en_landing_pricerules_mock_badge_active = /** @type {(inputs: Landing_Pricerules_Mock_Badge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`active`)
};

const de_landing_pricerules_mock_badge_active = /** @type {(inputs: Landing_Pricerules_Mock_Badge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktiv`)
};

const ru_landing_pricerules_mock_badge_active = /** @type {(inputs: Landing_Pricerules_Mock_Badge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`активно`)
};

/**
* | output |
* | --- |
* | "active" |
*
* @param {Landing_Pricerules_Mock_Badge_ActiveInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_badge_active = /** @type {((inputs?: Landing_Pricerules_Mock_Badge_ActiveInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Badge_ActiveInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_badge_active(inputs)
	if (locale === "de") return de_landing_pricerules_mock_badge_active(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_badge_active(inputs)
	return tr_landing_pricerules_mock_badge_active(inputs)
});